import { useGetList } from './useGetList'
import { useCreateTrainingModuleSession, useGetTrainingModuleSession } from './useSession'

export const trainingModules = {
  getList: useGetList,
  getSession: useGetTrainingModuleSession,
  createSession: useCreateTrainingModuleSession,
}
